// Tokens de thème pour les styles inline (style={{ color: T.primary }}). Source : styles/tokens.css.
const v = (name) => `var(--cf-${name})`;

export const T = {
  primary: v("primary"), primaryHover: v("primary-hover"), primarySoft: v("primary-soft"), primaryBorder: v("primary-border"), primaryText: v("primary-text"),
  accent: v("accent"), accentHover: v("accent-hover"), accentSoft: v("accent-soft"), accentText: v("accent-text"),
  info: v("info"), gradient: v("gradient"),
  success: v("success"), successText: v("success-text"), successSoft: v("success-soft"), successBorder: v("success-border"),
  warning: v("warning"), warningText: v("warning-text"), warningSoft: v("warning-soft"), warningBorder: v("warning-border"),
  danger: v("danger"), dangerText: v("danger-text"), dangerSoft: v("danger-soft"), dangerBorder: v("danger-border"),
  neutralSoft: v("neutral-soft"), neutralText: v("neutral-text"),
  text: v("text"), text2: v("text-2"), text3: v("text-3"),
  bg: v("bg"), bg2: v("bg-2"), surface: v("surface"), border: v("border"), borderStrong: v("border-strong"),
  radiusCard: v("radius-card"), radiusMd: v("radius-md"), radiusSm: v("radius-sm"),
  shadowCard: v("shadow-card"), shadowBtn: v("shadow-btn"), focusRing: v("focus-ring"),
};

export default T;

// Couleurs renvoyées par l'API (NBA, mode, statut KPI) → tokens, pour suivre le thème actif.
const API_MAP = { "#2D6EFF": T.primary, "#4F46E5": T.primary, "#DBEAFE": T.primarySoft, "#B91C1C": T.dangerText, "#EF4444": T.danger, "#F59E0B": T.warning, "#D97706": T.warning, "#C2410C": T.warningText, "#FEF3C7": T.warningSoft, "#FFEDD5": T.warningSoft, "#FEE2E2": T.dangerSoft, "#10B981": T.success, "#047857": T.successText, "#D1FAE5": T.successSoft, "#94A3B8": T.text3, "#64748B": T.text2, "#0F172A": T.text, "#E2E8F0": T.border, "#F8FAFC": T.bg2 };
export const apiColor = (hex) => (hex && API_MAP[String(hex).toUpperCase()]) || hex;
